var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd24f;}.cls-2{fill:#fc9b28;}.cls-3{fill:#b5e0f0;}.cls-4{fill:#4ea0ca;}.cls-5{fill:#b06e53;}.cls-6{fill:#ffd7a3;}.cls-7{fill:#fdc88e;}.cls-8{fill:#ffe1b2;}.cls-9{fill:#ffb422;}.cls-10{fill:#29394a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18-engineer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_18-engineer",
    "data-name": "18-engineer"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22,
    y: 58,
    width: 20,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,44V54H17V42.2a13.751,13.751,0,0,1,4-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,41.08a13.751,13.751,0,0,1,4,1.12V54H43V41.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47 54 47 63 42 63 42 58 22 58 22 63 17 63 17 54 21 54 43 54 47 54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,48l-3,3-8-7V41.08A8.667,8.667,0,0,1,22,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,41.08V44l-8,7-3-3,10-7A8.667,8.667,0,0,1,43,41.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17,54v9H10V54.62c0-7.57,3.71-10.93,7-12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54,54.62V63H47V42.2C50.29,43.69,54,47.05,54,54.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "43 54 21 54 21 44 29 51 32 48 35 51 43 44 43 54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24,19l-2,3H19.01c-.01-.13-.01-.25-.01-.38A13.4,13.4,0,0,1,19.25,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,21.62l-.01.38H42l-2-3h4.75A13.4,13.4,0,0,1,45,21.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.01,36.42C39.17,41,42,41,42,41L32,48,22,41s2.83,0,2.99-4.58a10.813,10.813,0,0,0,14.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48,25a3,3,0,0,1-3,3h-.92l.91-6H46a2.006,2.006,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.01,22a22.923,22.923,0,0,0,.91,6H19a3,3,0,0,1-3-3V24a2.006,2.006,0,0,1,2-2h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.01,36.42a10.813,10.813,0,0,1-14.02,0A17.292,17.292,0,0,1,19.92,28a22.923,22.923,0,0,1-.91-6H22l2-3H40l2,3h2.99l-.91,6a19.85,19.85,0,0,1-2.31,5.21A14.269,14.269,0,0,1,39.01,36.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,1.32V9H29V1.32a14.223,14.223,0,0,1,6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32,13c-6,0-11.22,1.24-13.96,3.07L18,16V15A14.051,14.051,0,0,1,29,1.32V9h6V1.32A14.051,14.051,0,0,1,46,15v1l-.04.07C43.22,14.24,38,13,32,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,19H16a3.757,3.757,0,0,1,2.04-2.93C20.78,14.24,26,13,32,13s11.22,1.24,13.96,3.07A3.757,3.757,0,0,1,48,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.01,36.42A10.82,10.82,0,0,1,26.5,37.5l8.443,8.443L42,41S39.17,41,39.01,36.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M47.414,41.29a14.668,14.668,0,0,0-4.286-1.2A10,10,0,0,0,42.022,40h0c-.183-.008-1.725-.178-1.983-3.169a15.516,15.516,0,0,0,2.573-3.082A20.433,20.433,0,0,0,44.807,29H45a4,4,0,0,0,4-4V24a3,3,0,0,0-3-3h-.029c-.014-.337-.03-.672-.065-1H48a1,1,0,0,0,1-1,4.326,4.326,0,0,0-2-3.406V15A14.961,14.961,0,0,0,41,3.037V3h-.047c-.13-.1-.246-.206-.379-.3A14.83,14.83,0,0,0,35.212.343a15.264,15.264,0,0,0-6.426,0A14.791,14.791,0,0,0,23.43,2.7c-.135.094-.252.205-.383.3H23v.037A14.965,14.965,0,0,0,17,15v.6A4.326,4.326,0,0,0,15,19a1,1,0,0,0,1,1h2.094c-.035.328-.051.663-.065,1H18a3,3,0,0,0-3,3v1a4,4,0,0,0,4,4h.192a18.053,18.053,0,0,0,4.769,7.828c-.246,2.992-1.8,3.164-1.983,3.172h0a9.62,9.62,0,0,0-1.1.087,14.7,14.7,0,0,0-4.3,1.2C13.126,42.857,9,46.442,9,54.62V63a1,1,0,0,0,1,1H54a1,1,0,0,0,1-1V54.62C55,46.442,50.874,42.857,47.414,41.29ZM41,62H23V59H41Zm1-5H22a1,1,0,0,0-1,1v4H18V55H46v7H43V58A1,1,0,0,0,42,57ZM25.771,38.215a11.76,11.76,0,0,0,12.462,0,5.163,5.163,0,0,0,1.718,3L32,46.779l-7.949-5.564A5.136,5.136,0,0,0,25.771,38.215ZM42,42.221v1.325l-6.954,6.086-1.5-1.5ZM30.45,48.136l-1.5,1.5L22,43.546V42.221ZM22,46.2l6.341,5.549a1,1,0,0,0,1.366-.046L32,49.414l2.293,2.293a1,1,0,0,0,1.365.046L42,46.2V53H22Zm22-3.942a12.982,12.982,0,0,1,2,.6V53H44ZM20,53H18V42.863a12.885,12.885,0,0,1,2-.6ZM47,24v1a2,2,0,0,1-1.753,1.975L45.85,23H46A1,1,0,0,1,47,24Zm-3.028-3H42.535l-.667-1h2.019C43.929,20.329,43.956,20.662,43.972,21ZM34,2.171V8H30V2.172A13.31,13.31,0,0,1,34,2.171ZM23,5.653V10h2V4.069a12.829,12.829,0,0,1,3-1.442V9a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V2.627A12.831,12.831,0,0,1,39,4.07V10h2V5.652a12.954,12.954,0,0,1,3.962,8.73C41.805,12.879,37.137,12,32,12s-9.808.879-12.962,2.382A12.956,12.956,0,0,1,23,5.653ZM18.6,16.9C21.275,15.112,26.412,14,32,14s10.725,1.112,13.408,2.9A4.821,4.821,0,0,1,46.629,18H17.372A4.827,4.827,0,0,1,18.6,16.9ZM20.113,20h2.019l-.667,1H20.029C20.045,20.66,20.072,20.327,20.113,20ZM17,25V24a1,1,0,0,1,1-1h.059a24.179,24.179,0,0,0,.565,3.962A2,2,0,0,1,17,25Zm3.88,2.72A22.2,22.2,0,0,1,20.061,23H22a1,1,0,0,0,.832-.445L24.535,20h14.93l1.7,2.555A1,1,0,0,0,42,23h1.8L43.1,27.785a18.764,18.764,0,0,1-2.175,4.887,13.222,13.222,0,0,1-2.561,2.982,9.811,9.811,0,0,1-12.729,0A16.431,16.431,0,0,1,20.88,27.72ZM11,54.62c0-5.035,1.683-8.637,5-10.741V62H11ZM53,62H48V43.879c3.316,2.1,5,5.706,5,10.741Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32,35a5.006,5.006,0,0,0,5-5H35a3,3,0,0,1-6,0H27A5.006,5.006,0,0,0,32,35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/생산팀.ec239f174912a95031e6c380beeaeb31.svg";
export { ForwardRef as ReactComponent };